import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { OrderTransport } from "src/app/transports/order";
import { IActionsModal } from "src/app/types/actionsModal";
import { DefaultSelected } from "src/app/components";
import { Order } from "src/app/types/orders/order";
import { useGetOrderById } from "src/app/hooks";

const RemoveRDModalContainer = (props: IActionsModal<Order>) => {
    const { entity, handleClose = () => {}, updateGridOnSave = () => {} } = props;
    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState();
    const { formatMessage } = useIntl();

    const { order, loading: orderLoading } = useGetOrderById(entity?.id);

    const handleSelectedChange = (value: any) => {
        setReason(value);
    };

    const handleSubmit = async () => {
        setLoading(true);

        if (!reason) return;

        try {
            const res = await OrderTransport.removeRD(entity.id, reason);
            await updateGridOnSave(res, false);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handleClose();
        } catch (error: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.action.removeRD" })}
            handleClose={handleClose}
            buttonConfirmationLabel={formatMessage({
                id: `common.action.removeRD`,
            })}
            disableConfirmation={reason === undefined}
            buttonConfirmationAction={handleSubmit}
            loading={loading || orderLoading}
            formId=""
            showModal={true}
        >
            <>
                <div className="d-flex gap-2">
                    <b>{formatMessage({ id: "common.field.moneySite" })}:</b>
                    <span>{order?.moneySite?.domain}</span>
                </div>

                <div className="d-flex gap-2">
                    <b>{formatMessage({ id: "common.field.manager" })}:</b>
                    <span>{`${order?.manager?.firstName} ${order?.manager?.lastName}`}</span>
                </div>

                <div className="d-flex gap-2">
                    <b>{formatMessage({ id: "common.field.rd" })}:</b>
                    <span>{order?.rd?.domain}</span>
                </div>
                <div className="d-flex gap-2 align-items-center">
                    <b>{formatMessage({ id: "common.field.reson" })}:</b>
                    <DefaultSelected
                        value={reason}
                        onChange={handleSelectedChange}
                        options={[
                            {
                                value: "Denied",
                                label: formatMessage({ id: "common.select.denied" }),
                            },
                            {
                                value: "Expired",
                                label: formatMessage({ id: "common.select.expired" }),
                            },
                        ]}
                    />
                </div>
            </>
        </SimpleModal>
    );
};

export default RemoveRDModalContainer;
